import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import classes from "App.module.css"
import "global.css"
import { PATH } from "utils/constants";
import PublicRoute from "components/shared/routes/PublicRoute";
import PrivateRoute from "components/shared/routes/PrivateRoute";
import { checkRoutePermission } from "utils/utils";
import HomeLayout from "components/layouts/homelayout/HomeLayout";
import 'react-tooltip/dist/react-tooltip.css'
import 'react-loading-skeleton/dist/skeleton.css'
import ShareReport from "components/pages/sharedreport/ShareReport";
import PrivacyPolicy from "components/pages/privacy/Privacy";
import Terms from "components/pages/terms-of-service/Terms";

function App() {

  const roleWiseRouting = createBrowserRouter([
    {
      path: "/share/:formName/:id",  // Use * to capture everything in formName
      element: <ShareReport />

    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />

    },
    {
      path: "/terms-of-service",
      element: <Terms />

    },
    //public routes
    ...Object.values(PATH.publicRoutes).map(route => ({
      path: route.path,
      element: <PublicRoute component={route.element} />,
    })),
    {
      //private routes
      path: "/",
      element: <PrivateRoute component={HomeLayout} />,
      children: [
        ...Object.values(PATH.privateRoutes)
          .map(child => ({
            path: child.path,
            element: child.element,
            permissionName: child.permissionName,
            children: child?.children && Object.values(child.children).map(x => ({
              path: x.path,
              element: x.element,
            }))
          }))
          .filter(child => checkRoutePermission(child.permissionName)),
        {
          path: "/",
          element: <Navigate to={PATH.privateRoutes.HOME.path} />
        },
        {
          path: "*",
          element: <Navigate to={PATH.privateRoutes.HOME.path} />
        },
      ]
    },
    {
      path: "*",
      element: <Navigate to="/" />
    },
  ])

  return (
    <div className={classes.app}>
      <RouterProvider router={roleWiseRouting} />
    </div>
  );
}

export default App;
